// extracted by mini-css-extract-plugin
export default {"container":"suggestions_container__305VV","settingsContainer":"suggestions_settingsContainer__DIiTh"};